import React from 'react';
import { PageContextProvider } from '@context/page-context-provider';
import { ApolloProvider } from '@apollo/client';
import { client } from './src/apollo/client';
import QueryParamsProviderRoot from './src/utils/QueryParamsProviderRoot';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import '@react-pdf-viewer/page-navigation/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import '@react-pdf-viewer/search/lib/styles/index.css';
import '@fontsource/inter/200.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>
    <QueryParamsProviderRoot>{element}</QueryParamsProviderRoot>
  </ApolloProvider>
);

// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => (
  <PageContextProvider value={props}>{element}</PageContextProvider>
);

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  const { pathname } = location;
  const pathsToCheck = ['/explore', '/pt/saiba-mais', '/es/explora'];

  return !pathsToCheck.includes(pathname);
};
